<template>
	<div class="com-list-content">
		<com-search :model="search" :transfer-model.sync="condition" v-slot="{data}" :table="$refs.table">
			<ui-text v-model="data.name" label="年级名称"/>
			<ui-template>
				<ui-button type="search"></ui-button>
				<ui-button type="add" @click="add">增加</ui-button>
			</ui-template>
		</com-search>
		<com-table ref="table" url="/admin/grade/list" :search="condition" v-slot="{data}">
			<ui-text v-model="data.name" label="年级名称"/>
			<ui-image v-model="data.img" label="封面"/>
			<ui-text v-model="data.sort" label="排序"/>
			<ui-select v-model="data.status" label="状态">
				<ui-option value="1" text="启用" tag-type="success"/>
				<ui-option value="0" text="禁用" tag-type="info"/>
			</ui-select>
			<ui-text v-model="data.createTime" label="创建时间"/>
			<ui-template label="操作">
				<ui-button type="edit" @click="edit(data)"/>
				<ui-button type="delete" @click="remove(data)"/>
			</ui-template>
		</com-table>
	</div>
</template>

<script>
export default {
	data(){
		return {
			search:{},
			condition:{},
		};
	},
	mounted(){
	},
	methods:{
		add(){
			this.$dialog('grade_detail',{type:'add',data:{}},()=>{
				this.$refs.table.refresh();
			})
		},
		edit(data){
			this.$dialog('grade_detail',{type:'edit',data:data},()=>{
				this.$refs.table.refresh();
			})
		},
		remove(data){
			this.$axios.delete('/admin/grade/option/'+data.id)
			.then(data=>{
				this.$refs.table.refresh();
			}).end();
		}
	}
}
</script>

<style>
</style>
